import { ShieldCheck } from "lucide-react";
import Reveal, { SectionHeading } from "../components/Reveal";
import { INDUSTRIES } from "../data";

export default function Industries() {
  return (
    <section id="industries" className="relative py-24 lg:py-32 bg-[#F3EFE6] border-y border-stone-200 overflow-hidden">
      <div className="pointer-events-none absolute bottom-0 right-0 h-[380px] w-[380px] rounded-full bg-amber-400/15 blur-[110px]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow="Industries We Serve" title={<>Where our components go to work</>} />
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="industries-grid">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind} delay={0.04 * i} y={18}>
              <div className="flex h-full items-center gap-4 rounded-xl border border-stone-200 bg-white px-5 py-5 hover:border-amber-500/60 hover:shadow-[0_12px_30px_rgba(150,112,31,0.1)] transition-colors">
                <span className="shrink-0 font-tech text-xs font-bold text-amber-700">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-[15px] font-medium text-stone-800 leading-snug">{ind}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-8 flex items-start gap-3 text-xs sm:text-sm text-stone-500 max-w-3xl" data-testid="industries-note">
            <ShieldCheck size={18} className="shrink-0 mt-0.5 text-stone-400" />
            All components for regulated industries are supplied subject to the customer's
            technical, qualification and applicable regulatory requirements.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
